import {takeEvery, takeLatest, put, select} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {
  POST_CONTACT_FORM,
  GET_MARKETING_STATISTIC,
  GET_MARKETING_STATISTIC_SUCCESS,
  SET_EMAIL_MARKETING_RESULT_PAGE_SPINNER,
  SET_EMAIL_MARKETING_TRIAL_DATE,
  GET_EMAIL_MARKETING_TRIAL_DATE,
  GET_EMAIL_MARKETING_CAMPAIGNS,
  GET_EMAIL_MARKETING_CAMPAIGNS_SUCCESS,
  GET_EMAIL_MARKETING_CAMPAIGNS_FAILURE,
  SET_EMAIL_MARKETING_CAMPAIGNS_SPINNER,
  GET_EMAIL_MARKETING_CAMPAIGN_DETAIL,
  GET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SUCCESS,
  SET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SPINNER,
  GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW,
  GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_SUCCESS,
  GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_FAILURE,
  SET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_SPINNER
} from 'store/emailMarketing/action';
import {
  postContactFormApi,
  getStatisticApi,
  getEmailMarketingTrialDateApi,
  getEmailMarketingCampaignsApi,
  getEmailMarketingCampaignDetailApi,
  getEmailMarketingCampaignPreviewApi
} from 'helpers/services/api/emailMarketing';
import {CAMPAIGN_STATUS_ALL} from 'helpers/constants/emailMarketing';
import sendGtmEvent from 'helpers/services/utils/gtm';

function* postContactForm({payload}) {
  try {
    const {data} = yield postContactFormApi(payload);
    if (data) {
      toast.success('Form was successfully submitted');
      const {activeLocation} = yield select((state) => state.user);
      sendGtmEvent('submit-marketing-form', {
        location_name: activeLocation?.FullName,
        location_id: activeLocation?._id
      });
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

function* getStatistic() {
  try {
    const locationId = yield select((state) => state.user.locationId);
    const {data} = yield getStatisticApi(locationId);
    if (data) {
      yield put(GET_MARKETING_STATISTIC_SUCCESS(data));
    }
  } catch (error) {
    yield put(SET_EMAIL_MARKETING_RESULT_PAGE_SPINNER(false));
    console.log('SAGA ERROR', error);
  }
}
function* getEmailMarketingTrialDate() {
  try {
    const locationId = yield select((state) => state.user.locationId);
    const {data} = yield getEmailMarketingTrialDateApi(locationId);
    if (data) {
      yield put(
        SET_EMAIL_MARKETING_TRIAL_DATE({
          startDate: data.startDate,
          status: data.status
        })
      );
    }
  } catch (error) {
    yield put(SET_EMAIL_MARKETING_RESULT_PAGE_SPINNER(false));
    console.log('SAGA ERROR', error);
  }
}
function* getCampaigns({payload}) {
  try {
    yield put(SET_EMAIL_MARKETING_CAMPAIGNS_SPINNER(true));
    const locationId = yield select((state) => state.user.locationId);
    const {status, search, page, pageSize} = payload || {};
    const {data} = yield getEmailMarketingCampaignsApi(locationId, {
      page,
      pageSize,
      // The server treats `all` as no filter, so send nothing instead.
      status: status === CAMPAIGN_STATUS_ALL ? null : status,
      search
    });
    if (data) {
      yield put(GET_EMAIL_MARKETING_CAMPAIGNS_SUCCESS(data));
    } else {
      yield put(GET_EMAIL_MARKETING_CAMPAIGNS_FAILURE());
    }
  } catch (error) {
    yield put(GET_EMAIL_MARKETING_CAMPAIGNS_FAILURE());
    console.log('SAGA ERROR', error);
  }
}

function* getCampaignDetail({payload}) {
  try {
    yield put(SET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SPINNER(true));
    const locationId = yield select((state) => state.user.locationId);
    const {campaignId, sourceType} = payload || {};
    const {data} = yield getEmailMarketingCampaignDetailApi(
      locationId,
      campaignId,
      {sourceType}
    );
    if (data) {
      yield put(GET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SUCCESS(data));
    } else {
      yield put(SET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SPINNER(false));
    }
  } catch (error) {
    yield put(SET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SPINNER(false));
    console.log('SAGA ERROR', error);
  }
}

function* getCampaignPreview({payload}) {
  try {
    yield put(SET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_SPINNER(true));
    const locationId = yield select((state) => state.user.locationId);
    const {campaignId, sourceType} = payload || {};
    const {data} = yield getEmailMarketingCampaignPreviewApi(
      locationId,
      campaignId,
      {sourceType}
    );
    if (data) {
      yield put(GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_SUCCESS(data));
    } else {
      yield put(GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_FAILURE());
    }
  } catch (error) {
    yield put(GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_FAILURE());
    console.log('SAGA ERROR', error);
  }
}

function* emailMarketingSaga() {
  yield takeEvery(POST_CONTACT_FORM, postContactForm);
  yield takeEvery(GET_MARKETING_STATISTIC, getStatistic);
  yield takeEvery(GET_EMAIL_MARKETING_TRIAL_DATE, getEmailMarketingTrialDate);
  yield takeLatest(GET_EMAIL_MARKETING_CAMPAIGNS, getCampaigns);
  yield takeLatest(GET_EMAIL_MARKETING_CAMPAIGN_DETAIL, getCampaignDetail);
  yield takeLatest(GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW, getCampaignPreview);
}

export default emailMarketingSaga;
